<template>
  <div class="kd-font-color-switcher">
    <div
      v-for="item in items"
      :key="item"
      class="kd-font-color-switcher__item"
      :style="{
        backgroundColor: item,
      }"
      @click="colorClicked(item)"
    ></div>
  </div>
</template>

<script>
import {
  SET_FONT_COLOR_FOR_ACTIVE_LAYER,
} from '@/store/mutation-types';

export default {
  data() {
    return {
    //   selected: '',
    };
  },
  props: {
    initial: String,
    items: Array,
  },
  methods: {
    colorClicked(hex) {
      this.selected = hex;
      this.$store.commit(SET_FONT_COLOR_FOR_ACTIVE_LAYER, hex);
    },
    // isSelected(hex) {
    //   return this.selected === hex;
    // },
  },
  watch: {
    // initial(value) { this.selected = value; },
  },
};
</script>

<style lang="scss">
.kd-font-color-switcher {
  display: flex;
  flex-wrap: wrap;
  margin-top: -10px; // needed, because of wrapping elements (item top margin)
}
.kd-font-color-switcher__item {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
  border: 2px solid #DDDDDD;

  // &--selected {
  //   border-color: #01A4E0;
  // }

  &:hover {
    opacity: 0.8;
  }
}
</style>
